import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";


import Layout from "../../components/Layout";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {clearUser} from "../../redux/actions/userActions";
import {getTokenAuthStorage} from "../../utils";
import {clearPanel} from "../../redux/actions/panelActions";

const LoginRoute = ({
                      component: Component,
                      LayoutProps,
                      ...props
                    }) => {
  /* const dateTime = (new Date()).getTime(); */
  const auth = getTokenAuthStorage();
  if(auth && auth.token /* && props.expireSession && props.expireSession>dateTime */){
    return <Redirect
      to={{
        pathname: "/panel/cobertura"
      }}
    />
  }
  const clearUser = props.clearUser;
  const clearPanel = props.clearPanel;
  clearUser();
  clearPanel();
  return <Route {...props}>
    <Layout {...LayoutProps}>
      <Component {...props} />
    </Layout>
  </Route>
};

LoginRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  exact: PropTypes.bool,
  /* expireSession: PropTypes.number, */
  LayoutProps: PropTypes.object
};

 const mapStateToProps = state => {
  return {
    /* expireSession: state.user.expireSession */
  };
}; 

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearUser: clearUser,
      clearPanel: clearPanel
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoginRoute);